/* global debounce, theme */
/* Įmonės rekvizitų laukai krepšelyje — saugomi kaip cart attributes (keliauja į užsakymą).
   Veikia ir krepšelio puslapyje, ir drawer'yje (AJAX, kaip cart-note.js). */
if (!customElements.get('company-fields')) {
  class CompanyFields extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.js-company-toggle');
      this.wrap = this.querySelector('.js-company-inputs');
      this.inputs = Array.from(this.querySelectorAll('input[name^="attributes"]'));
      this.opts = {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
      };

      this.toggle.addEventListener('change', this.onToggle.bind(this));
      const debounced = debounce(this.save.bind(this), 300);
      this.inputs.forEach((i) => i.addEventListener('input', debounced));
    }

    onToggle() {
      if (this.toggle.checked) {
        this.wrap.hidden = false;
      } else {
        this.wrap.hidden = true;
        this.inputs.forEach((i) => { i.value = ''; });
        this.save();
      }
    }

    save() {
      const attributes = {};
      this.inputs.forEach((i) => {
        const key = i.name.replace('attributes[', '').replace(']', '');
        attributes[key] = i.value;
      });
      this.opts.body = JSON.stringify({ attributes });
      fetch(theme.routes.cartUpdate, this.opts);
    }
  }
  customElements.define('company-fields', CompanyFields);
}
